import { DashboardActivityLog } from "./DashboardActivityLog";
import { DashboardToday } from "./DashboardToday";
import MobileHeader from "../layout/MobileHeader";
import { MobileContent } from "../layout/MobileContent";
export const MobileDashboard = () => (
  <>
    <MobileHeader title="Главная" />
    <MobileContent>
      <div className="space-y-6">
        <DashboardToday />
        <DashboardActivityLog />
      </div>
    </MobileContent>
  </>
);
